export default {"src":"/_next/static/media/HolisticandPreventiveCare.142e0ec6.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};